import { Inject, Injectable } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';
import { User } from '../shared/constants/user-info';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthenticationResult, EventMessage, RedirectRequest } from '@azure/msal-browser';
import { UserConfigService } from '../shared/services/user-config/user-config.service';
import { LoggerService } from '../shared/services/logger/logger.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  userData: User;
  isIframe: boolean = false;
  SCOPE: Array<string>;
  private isLoggedIn$: BehaviorSubject<boolean>;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private userConfig: UserConfigService,
    private loggerService: LoggerService,
    private httpService: HttpClient) {
    this.isLoggedIn$ = new BehaviorSubject(false);
  }

  setLoggedIn(value: boolean) {
    this.isLoggedIn$.next(value);
  }
  getIsLoggedIn(): Observable<boolean> {
    return this.isLoggedIn$ as Observable<boolean>
  }

  getProfileDetails() {
    this.httpService.get(environment.AUTH_RESOURCE_LINK.self).subscribe((res) => {
      this.loggerService.log("Profile Details : ", res);
    })
  }

  loginRedirect() {
    if (environment.isLocal) {
      this.triggerLocalAuth();
    } else {
      this.msalAuthLogin();
    }
  }

  msalAuthLogin() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  logout() {
    this.msalService.logoutRedirect();
  }

  /**
   * LogOutWithPopup: method logs the user out of the
   * application using a popup utilizing the MSAL service 
   * to handle the logout process.
   */
  logOutWithPopup = () => this.msalService.logout();

  triggerLocalAuth() {
    this.loggerService.log("In Local auth");
    this.userConfig.setUserInfo({ userId: environment.LOCAL_AUTH.userId, userName: environment.LOCAL_AUTH.userName });
    this.setLoggedIn(true);
    //after this api calls for projects details.
  }

  checkAndSetActiveAccount() {
    let activeAccount = this.msalService.instance.getActiveAccount();
    const accounts = this.msalService.instance.getAllAccounts();
    if (!activeAccount && accounts?.length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    } else if (accounts.length === 0) {
      // No user signed in
      this.loginRedirect();
    } else if (activeAccount) {
      this.userConfig.setUserInfo({ userId: activeAccount.username, userName: activeAccount.name });
      this.setLoggedIn(true);
    }
  }

  handleLoginSuccess(result: EventMessage) {
    const payload = result.payload as AuthenticationResult;
    this.msalService.instance.setActiveAccount(payload.account);
    let activeAccount = this.msalService.instance.getActiveAccount();
    this.loggerService.log("Active account details : ", activeAccount);
    if (activeAccount) {
      this.userConfig.setUserInfo({ userId: activeAccount.username, userName: activeAccount.name });
      this.setLoggedIn(true);
    };
  }

}
